import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "video-lid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "video-gradient-bg vid-space" }, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "video-timer" }
const _hoisted_5 = { class: "video-top vid-space" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Please complete the form for instant access to this video. ", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "video-success" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "yt-iframe" }, [
    /*#__PURE__*/_createCommentVNode(" The iframe loads here ")
  ])
], -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["video-wrpr col-12", { 'no-key': $setup.noKey }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode(" No Gate Click "),
        _renderSlot(_ctx.$slots, "no-gate-video"),
        _createCommentVNode(" Video Thumbnail "),
        _createElementVNode("div", {
          class: "video-thumb",
          style: _normalizeStyle('background-image: url(' + $setup.thumbnailUrl + ');')
        }, null, 4 /* STYLE */),
        _createCommentVNode(" video gradient-bg "),
        _hoisted_3,
        _createCommentVNode(" Video Timer "),
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.videoData.runtime), 1 /* TEXT */),
        _createCommentVNode(" Video Top "),
        _createElementVNode("div", _hoisted_5, [
          _createVNode($setup["playButton"]),
          _hoisted_6
        ]),
        _createCommentVNode(" The Form "),
        _renderSlot(_ctx.$slots, "resource-form")
      ]),
      _createCommentVNode(" Video on Form Success "),
      _hoisted_7
    ], 2 /* CLASS */)
  ]))
}